"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    arrowHeights: function() {
        return arrowHeights;
    },
    popoverSurfaceClassNames: function() {
        return popoverSurfaceClassNames;
    },
    usePopoverSurfaceStyles_unstable: function() {
        return usePopoverSurfaceStyles_unstable;
    }
});
const _react = require("@griffel/react");
const popoverSurfaceClassNames = {
    root: 'fui-PopoverSurface'
};
const arrowHeights = {
    small: 6,
    medium: 8,
    large: 8
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        sj55zd: "f19n0e5",
        De3pzq: "fxugw4r",
        E5pizo: "f1hg901r",
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "f9ggezi",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi",
        B93otf3: "f18k4bn6",
        vin17d: "fo1kyvf",
        Ezkn3b: "fetxo7e",
        nyiy2g: "f8x1vz1",
        swvrvq: "f8g0anz",
        Bkovbt3: "fezwn9i",
        hgjdhn: "fz5efge",
        fsy9dk: "f1ydixl4",
        B3ogreh: "f8dgqj5",
        jv49x5: "fnyfnr8",
        Bk7o48c: "fgw77r4",
        Bv12yb3: "ftje0s4",
        z0t1cu: "fi19xcv",
        Bks05zx: "f1mzajhk",
        Bvtglag: "fjp4h9y"
    },
    inline: {
        Bj3rh1h: "f19g0ac"
    },
    inverted: {
        De3pzq: "fg3r6xk",
        sj55zd: "fonrgv7"
    },
    brand: {
        De3pzq: "ffp7eso",
        sj55zd: "f1phragk"
    },
    smallPadding: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1sy4kr4"
    },
    mediumPadding: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f4zyqsv"
    },
    largePadding: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "fop8ug2"
    },
    smallArrow: {
        a9b677: "f1ekdpwm",
        Bqenvij: "f83vc9z"
    },
    mediumLargeArrow: {
        a9b677: "f1kmc0fn",
        Bqenvij: "fb6lvc5"
    },
    arrow: {
        qhf8xq: "f1euv43f",
        De3pzq: "f1u2r49w",
        Bcdw1i0: "fd7fpy0",
        Bj3rh1h: "f1bsuimh",
        Ftih45: "f1wl9k8s",
        B1puzpu: "f1wkw4r9",
        Brfgrao: "f1j7ml58",
        Bcvre1j: "fyl8oag",
        Ccq8qp: "frdoeuz",
        Baz25je: "fb81m9q",
        cmx5o7: "f1ljr5q2",
        Bk5zm6e: 0,
        m598lv: 0,
        B4f6apu: 0,
        eqrjj: "f15tymiq",
        Bqjgrrk: 0,
        qa3bma: 0,
        y0oebl: 0,
        Bcgcnre: "fi8wnwo",
        Budzafs: [
            "f9e5op9",
            "f112wvtl"
        ],
        Hv9wc6: "f16cagkn",
        hl6cv3: "f1773hnp",
        c8svkw: "fw7o64x",
        yayu3t: "f1v7783n",
        nr3p0k: "f1f0d6v",
        rhl9o9: "fh2hsk5",
        wiz9v7: "f1gj3y7g",
        B6q6orb: "f11yvu4",
        ndpsmx: "f17lejdj"
    }
}, {
    d: [
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".f1hg901r{box-shadow:var(--shadow16);}",
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        [
            ".f9ggezi{border:1px solid var(--colorTransparentStroke);}",
            {
                p: -2
            }
        ],
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".f18k4bn6{animation-composition:accumulate;}",
        ".fo1kyvf{animation-duration:var(--durationSlower);}",
        ".fetxo7e{animation-timing-function:var(--curveDecelerateMid);}",
        ".f8x1vz1{--fui-positioning-slide-distance-x:0px;}",
        ".f8g0anz{--fui-positioning-slide-distance-y:10px;}",
        ".fezwn9i[data-popper-placement^=right]{--fui-positioning-slide-distance-x:-10px;}",
        ".fz5efge[data-popper-placement^=right]{--fui-positioning-slide-distance-y:0px;}",
        ".f1ydixl4[data-popper-placement^=bottom]{--fui-positioning-slide-distance-x:0px;}",
        ".f8dgqj5[data-popper-placement^=bottom]{--fui-positioning-slide-distance-y:-10px;}",
        ".fnyfnr8[data-popper-placement^=left]{--fui-positioning-slide-distance-x:10px;}",
        ".fgw77r4[data-popper-placement^=left]{--fui-positioning-slide-distance-y:0px;}",
        ".ftje0s4{animation-name:f5j8bii,f79suad;}",
        ".f19g0ac{z-index:1;}",
        ".fg3r6xk{background-color:var(--colorNeutralBackgroundStatic);}",
        ".fonrgv7{color:var(--colorNeutralForegroundStaticInverted);}",
        ".ffp7eso{background-color:var(--colorBrandBackground);}",
        ".f1phragk{color:var(--colorNeutralForegroundOnBrand);}",
        [
            ".f1sy4kr4{padding:12px;}",
            {
                p: -1
            }
        ],
        [
            ".f4zyqsv{padding:16px;}",
            {
                p: -1
            }
        ],
        [
            ".fop8ug2{padding:20px;}",
            {
                p: -1
            }
        ],
        ".f1ekdpwm{width:8.484px;}",
        ".f83vc9z{height:8.484px;}",
        ".f1kmc0fn{width:11.312px;}",
        ".fb6lvc5{height:11.312px;}",
        ".f1euv43f{position:absolute;}",
        ".f1u2r49w{background-color:inherit;}",
        ".fd7fpy0{visibility:hidden;}",
        ".f1bsuimh{z-index:-1;}",
        ".f1wl9k8s::before{content:\"\";}",
        ".f1wkw4r9::before{visibility:visible;}",
        ".f1j7ml58::before{position:absolute;}",
        ".fyl8oag::before{box-sizing:border-box;}",
        ".frdoeuz::before{width:inherit;}",
        ".fb81m9q::before{height:inherit;}",
        ".f1ljr5q2::before{background-color:inherit;}",
        [
            ".f15tymiq::before{border-right:1px solid var(--colorTransparentStroke);}",
            {
                p: -1
            }
        ],
        [
            ".fi8wnwo::before{border-bottom:1px solid var(--colorTransparentStroke);}",
            {
                p: -1
            }
        ],
        ".f9e5op9::before{border-bottom-right-radius:var(--borderRadiusSmall);}",
        ".f112wvtl::before{border-bottom-left-radius:var(--borderRadiusSmall);}",
        ".f16cagkn::before{transform:rotate(var(--fui-positioning-angle)) translate(0, 50%) rotate(45deg);}",
        "[data-popper-placement^=\"top\"] .f1773hnp{bottom:-1px;}",
        "[data-popper-placement^=\"top\"] .fw7o64x{--fui-positioning-angle:0;}",
        "[data-popper-placement^=\"right\"] .f1v7783n{left:-1px;}",
        "[data-popper-placement^=\"right\"] .f1f0d6v{--fui-positioning-angle:90deg;}",
        "[data-popper-placement^=\"bottom\"] .fh2hsk5{top:-1px;}",
        "[data-popper-placement^=\"bottom\"] .f1gj3y7g{--fui-positioning-angle:180deg;}",
        "[data-popper-placement^=\"left\"] .f11yvu4{right:-1px;}",
        "[data-popper-placement^=\"left\"] .f17lejdj{--fui-positioning-angle:270deg;}"
    ],
    k: [
        "@keyframes f5j8bii{from{opacity:0;}to{opacity:1;}}",
        "@keyframes f79suad{from{transform:translate(var(--fui-positioning-slide-distance-x), var(--fui-positioning-slide-distance-y));}}"
    ],
    m: [
        [
            "@media (prefers-reduced-motion){.fi19xcv[data-popper-placement]{animation-duration:1ms;}}",
            {
                m: "(prefers-reduced-motion)"
            }
        ],
        [
            "@media (prefers-reduced-motion){.f1mzajhk[data-popper-placement]{animation-name:f5j8bii;}}",
            {
                m: "(prefers-reduced-motion)"
            }
        ]
    ],
    t: [
        "@supports not (animation-composition: accumulate){.fjp4h9y[data-popper-placement]{animation-name:f5j8bii;}}"
    ]
});
const usePopoverSurfaceStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(popoverSurfaceClassNames.root, styles.root, state.inline && styles.inline, state.size === 'small' && styles.smallPadding, state.size === 'medium' && styles.mediumPadding, state.size === 'large' && styles.largePadding, state.appearance === 'inverted' && styles.inverted, state.appearance === 'brand' && styles.brand, state.root.className);
    state.arrowClassName = (0, _react.mergeClasses)(styles.arrow, state.size === 'small' ? styles.smallArrow : styles.mediumLargeArrow);
    return state;
}; //# sourceMappingURL=usePopoverSurfaceStyles.styles.js.map
